/**
 * useSpriteFrames resolves an AnimatedSprite2D's or AnimatedSprite3D's `sprite_frames` reference into
 * its animations map and the resource pools its frame textures resolve against.
 * Both homes hand the same property bag to `decodeSpriteFrames`, so the decode
 * never learns which one it came from.
 */
import { useMemo } from 'react';
import { useSceneResources } from '../../../r3f/SceneResourcesContext';
import { useResourceResolution } from '../../useSubOrExtResource';
import { decodeSpriteFrames } from './decode';
const EMPTY = { spriteFrames: null, status: 'unavailable' };
const PENDING = { spriteFrames: null, status: 'pending' };
export function useSpriteFrames(spriteFramesRef) {
    const { scoped, status } = useResourceResolution(spriteFramesRef, useSceneResources());
    return useMemo(() => {
        if (status === 'pending')
            return PENDING;
        const decoded = scoped ? decodeSpriteFrames(scoped.resource.data) : null;
        if (!scoped || !decoded)
            return EMPTY;
        return {
            spriteFrames: {
                resource: scoped.resource,
                animations: decoded.animations,
                subResources: scoped.resources.internalResources,
                externalResources: scoped.resources.externalResources,
            },
            status: 'loaded',
        };
    }, [scoped, status]);
}
//# sourceMappingURL=useSpriteFrames.js.map